import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const TelegramLinkNotification = () => {
  const navigate = useNavigate();
  const [hasShownNotification, setHasShownNotification] = useState(false);

  const {
    userProfile: { data: userProfile },
  } = useSelector((state) => state.user);

  useEffect(() => {
    const shownThisSession = sessionStorage.getItem(
      "telegram_notification_shown"
    );

    if (hasShownNotification || shownThisSession === "true") {
      return;
    }

    if (userProfile && userProfile.tariff_info) {
      const telegramNotLinked = !userProfile.telegram_linked;

      if (telegramNotLinked) {
        const timer = setTimeout(() => {
          toast.info(
            <div className="tw-cursor-pointer">
              <strong className="tw-text-lg tw-font-semibold tw-text-gray-900">
                💬 Подключите Telegram
              </strong>
              <p className="tw-mt-2 tw-text-sm tw-text-gray-700 tw-leading-relaxed">
                Привяжите Telegram в Профиле, чтобы начать пользоваться телеграм
                ботом.
              </p>
            </div>,
            {
              autoClose: 8000,
              onClick: () => {
                navigate("/account/edit");
              },
              className: "tw-cursor-pointer",
            }
          );

          sessionStorage.setItem("telegram_notification_shown", "true");
          setHasShownNotification(true);
        }, 1500);

        return () => clearTimeout(timer);
      }
    }
  }, [userProfile, navigate, hasShownNotification]);
  return null;
};

export default TelegramLinkNotification;
